import { useCallback } from "react";

import { useSearchParams } from "react-router";

/**
 * Hook to toggle a boolean search param on or off in the URL.
 *
 * @param key - The search param key to toggle
 * @param defaultValue - Optional default if the param is not present
 */
export function useToggleSearchParam(key: string, defaultValue = false) {
  const [searchParams, setSearchParams] = useSearchParams();

  const isEnabled =
    searchParams.get(key) === "true" ||
    (defaultValue && !searchParams.has(key));

  const toggle = useCallback(() => {
    const newParams = new URLSearchParams(searchParams);
    if (isEnabled) {
      newParams.delete(key);
    } else {
      newParams.set(key, "true");
    }
    setSearchParams(newParams, { replace: true });
  }, [isEnabled, key, searchParams, setSearchParams]);

  return [isEnabled, toggle] as const;
}
